module.exports = __webpack_public_path__ + "img/panelView_strong_Bg_2_1.eb88acf9.png";